"use client";

import { Search, Handshake, CircleCheck as CheckCircle } from 'lucide-react';
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowItWorks3StepProcess() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const steps = [{
    number: "01",
    title: "Αναζήτηση & Έμπνευση",
    body: "Ανακαλύψτε χιλιάδες επιλεγμένες διαμονές χωρίς περιττές πληροφορίες. Κάθε επιλογή είναι προσεγμένη για τη δική σας άνεση.",
    duration: "ΆΜΕΣΑ",
    Icon: Search,
    rotation: "-rotate-2",
    hoverRotation: "md:hover:rotate-0"
  }, {
    number: "02",
    title: "Επιλογή με Σιγουριά",
    body: "Αποκλειστικές προσφορές από άμεσες συνεργασίες με ξενοδοχεία. Διαφανή τιμολόγηση, χωρίς κρυμμένα έξοδα.",
    duration: "ΕΞΑΣΦΑΛΙΣΜΈΝΟ",
    Icon: Handshake,
    rotation: "rotate-[1.5deg]",
    hoverRotation: "md:hover:rotate-0"
  }, {
    number: "03",
    title: "Ασφαλής Κράτηση",
    body: "Άμεση επιβεβαίωση στο email με το voucher σας. Υποστήριξη ταξιδίου 24/7 για ησυχία νου.",
    duration: "ΕΠΙΒΕΒΑΊΩΣΗ",
    Icon: CheckCircle,
    rotation: "-rotate-1",
    hoverRotation: "md:hover:rotate-0"
  }];
  return <section data-section-id="1124" id="how-it-works-3-step-process" className="bg-background text-foreground py-28 md:py-40 relative overflow-hidden" style={{
    borderTop: "2px solid var(--foreground)"
  }}>
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        {}
        <div ref={headerRef} className={`transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="font-default text-xs md:text-sm uppercase tracking-[0.18em] text-foreground/70 mb-10 md:mb-16" style={{
          letterSpacing: "0.18em"
        }}>
            § ΦΑΣΗ-01 / ΠΩΣ ΛΕΙΤΟΥΡΓΕΙ
          </div>

          <h2 className="font-default text-foreground leading-[0.92] mb-6" style={{
          fontSize: "clamp(2.5rem, 6vw, 5.5rem)",
          letterSpacing: "-0.025em"
        }}>
            <span>Η Πορεία Προς Την </span>
            <span className="relative inline-block align-baseline">
              <span className="relative inline-block px-5 md:px-7 py-1 md:py-2" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)",
              border: "2px solid var(--foreground)",
              borderRadius: "0.5rem",
              transform: "rotate(4deg)",
              boxShadow: "4px 4px 0 var(--foreground)"
            }}>
                Ιδανική Κράτηση
                {}
                <svg className="absolute -bottom-1 -right-1 w-4 h-4 md:w-5 md:h-5" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M2 22 Q 12 12, 22 2 L 22 22 Z" fill="var(--background)" stroke="var(--foreground)" strokeWidth="2" />
                </svg>
              </span>
            </span>
          </h2>

          {}
          <svg className="mb-8 text-foreground" width="180" height="14" viewBox="0 0 180 14" fill="none" aria-hidden="true">
            <path d="M2 8 Q 20 2, 40 8 T 80 8 T 120 8 T 160 8 L 178 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
          </svg>

          <p className="font-default text-foreground/70 max-w-xl" style={{
          fontSize: "18px",
          lineHeight: "1.55"
        }}>
            Τρία απλά βήματα. Εγγυημένα αποτελέσματα. Επαγγελματική εξειδίκευση από την αναζήτηση μέχρι την ολοκλήρωση της κράτησης.
          </p>
        </div>

        {}
        <div ref={cardsRef} className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 lg:gap-12 relative">
          {steps.map((step, i) => {
          const Icon = step.Icon;
          const isLast = i === steps.length - 1;
          return <div key={i} data-index={i} className={`relative transition-all duration-700 ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 120}ms`
          }}>
                <Card className={`group bg-card border-[3px] border-foreground rounded-lg p-7 md:p-8 transform ${step.rotation} ${step.hoverRotation} transition-all duration-300 relative`} style={{
              boxShadow: "4px 4px 0 var(--foreground)",
              transitionTimingFunction: "cubic-bezier(0.34,1.56,0.64,1)"
            }} onMouseEnter={e => {
              (e.currentTarget as HTMLElement).style.boxShadow = "8px 8px 0 var(--primary)";
            }} onMouseLeave={e => {
              (e.currentTarget as HTMLElement).style.boxShadow = "4px 4px 0 var(--foreground)";
            }}>
                  {}
                  <span className="absolute top-2 left-2 w-3 h-3" style={{
                borderTop: "2px solid var(--foreground)",
                borderLeft: "2px solid var(--foreground)"
              }} aria-hidden="true" />
                  <span className="absolute top-2 right-2 w-3 h-3" style={{
                borderTop: "2px solid var(--foreground)",
                borderRight: "2px solid var(--foreground)"
              }} aria-hidden="true" />
                  <span className="absolute bottom-2 left-2 w-3 h-3" style={{
                borderBottom: "2px solid var(--foreground)",
                borderLeft: "2px solid var(--foreground)"
              }} aria-hidden="true" />
                  <span className="absolute bottom-2 right-2 w-3 h-3" style={{
                borderBottom: "2px solid var(--foreground)",
                borderRight: "2px solid var(--foreground)"
              }} aria-hidden="true" />

                  {}
                  <div className="font-default leading-none text-secondary" style={{
                fontSize: "clamp(4.5rem, 7vw, 6rem)",
                WebkitTextStroke: "2px var(--foreground)"
              }}>
                    {step.number}
                  </div>

                  {}
                  <div className="flex justify-center my-6">
                    <div className="inline-flex items-center justify-center w-20 h-20 rounded-lg" style={{
                  border: "2px solid var(--foreground)",
                  backgroundColor: "var(--background)"
                }}>
                      <Icon className="w-10 h-10 text-foreground" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    </div>
                  </div>

                  {}
                  <h3 className="font-default text-foreground mb-3" style={{
                fontSize: "clamp(1.5rem, 2.5vw, 2.25rem)",
                letterSpacing: "-0.01em",
                lineHeight: "1.05"
              }}>
                    {step.title}
                  </h3>

                  {}
                  <p className="font-default text-foreground/75 mb-5" style={{
                fontSize: "1rem",
                lineHeight: "1.55"
              }}>
                    {step.body}
                  </p>

                  {}
                  <div className="font-default uppercase text-foreground/60" style={{
                fontSize: "11px",
                letterSpacing: "0.12em"
              }}>
                    {step.duration}
                  </div>
                </Card>

                {}
                {!isLast && <>
                    {}
                    <svg className="hidden md:block absolute top-1/2 -right-6 lg:-right-8 w-12 lg:w-16 h-12 text-primary pointer-events-none" viewBox="0 0 64 48" fill="none" aria-hidden="true" style={{
                transform: "translateY(-50%)"
              }}>
                      <path d="M2 24 Q 16 14, 30 26 T 56 22" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                      <path d="M56 22 L 48 16 M 56 22 L 50 30" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                    </svg>

                    {}
                    <svg className="md:hidden mx-auto mt-6 w-12 h-14 text-primary" viewBox="0 0 48 64" fill="none" aria-hidden="true">
                      <path d="M24 2 Q 14 16, 26 30 T 22 56" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                      <path d="M22 56 L 14 50 M 22 56 L 30 50" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
                    </svg>
                  </>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}